// Área "profile" — preenchida na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const profile = {
  pt: {
    'profile.loading': 'Carregando perfil...',
    'profile.title': 'Meu Perfil',
    'profile.subtitle': 'Gerencie suas informações pessoais e configurações',
    'profile.defaultName': 'Cliente DogBank',
    'profile.customerSince': 'Cliente desde 2023',
    'profile.premiumAccount': 'Conta Premium',
    'profile.verified': 'Verificado',
    'profile.personalInfo': 'Informações Pessoais',
    'profile.fullName': 'Nome Completo',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefone',
    'profile.pixKey': 'Chave PIX',
    'profile.address': 'Endereço',
    'profile.street': 'Logradouro',
    'profile.complement': 'Complemento',
    'profile.neighborhood': 'Bairro',
    'profile.cityState': 'Cidade/Estado',
    'profile.zipCode': 'CEP',
    'profile.bankingData': 'Dados Bancários',
    'profile.bank': 'Banco',
    'profile.bankCode': 'Código: {code}',
    'profile.agency': 'Agência',
    'profile.account': 'Conta',
    'profile.appearance': 'Aparência do aplicativo',
    'profile.appearanceDesc': 'Escolha a cor de marca usada nesta conta.',
    'profile.appColorAria': 'Cor do aplicativo',
    'profile.appearanceNote': 'A preferência é salva só para este usuário e aplicada imediatamente.',
    'profile.creditAnalysis': 'Análise de Crédito',
    'profile.scoreOf': 'de {max}',
    'profile.ratingExcellent': 'Excelente',
    'profile.totalLimit': 'Limite Total',
    'profile.usedLimit': 'Limite Usado',
    'profile.availableLimit': 'Limite Disponível',
    'profile.utilized': '{pct}% utilizado',
    'profile.noLatePayments': 'Sem atrasos',
    'profile.accountActive': 'Conta ativa há {age}',
    'profile.accountAgeValue': '3 anos e 2 meses',
    'profile.scoreTips': 'Dicas para seu Score',
    'profile.rec1': 'Mantenha seus pagamentos em dia',
    'profile.rec2': 'Evite utilizar mais de 30% do limite',
    'profile.rec3': 'Diversifique suas fontes de crédito',
    'profile.logout': 'Sair da Conta',
    'profile.backToDashboard': 'Voltar ao Dashboard',
  },
  es: {
    'profile.loading': 'Cargando perfil...',
    'profile.title': 'Mi Perfil',
    'profile.subtitle': 'Gestiona tu información personal y configuración',
    'profile.defaultName': 'Cliente DogBank',
    'profile.customerSince': 'Cliente desde 2023',
    'profile.premiumAccount': 'Cuenta Premium',
    'profile.verified': 'Verificado',
    'profile.personalInfo': 'Información Personal',
    'profile.fullName': 'Nombre Completo',
    'profile.email': 'Correo electrónico',
    'profile.phone': 'Teléfono',
    'profile.pixKey': 'Clave PIX',
    'profile.address': 'Dirección',
    'profile.street': 'Domicilio',
    'profile.complement': 'Complemento',
    'profile.neighborhood': 'Barrio',
    'profile.cityState': 'Ciudad/Estado',
    'profile.zipCode': 'Código Postal',
    'profile.bankingData': 'Datos Bancarios',
    'profile.bank': 'Banco',
    'profile.bankCode': 'Código: {code}',
    'profile.agency': 'Agencia',
    'profile.account': 'Cuenta',
    'profile.appearance': 'Apariencia de la aplicación',
    'profile.appearanceDesc': 'Elige el color de marca usado en esta cuenta.',
    'profile.appColorAria': 'Color de la aplicación',
    'profile.appearanceNote': 'La preferencia se guarda solo para este usuario y se aplica de inmediato.',
    'profile.creditAnalysis': 'Análisis de Crédito',
    'profile.scoreOf': 'de {max}',
    'profile.ratingExcellent': 'Excelente',
    'profile.totalLimit': 'Límite Total',
    'profile.usedLimit': 'Límite Usado',
    'profile.availableLimit': 'Límite Disponible',
    'profile.utilized': '{pct}% utilizado',
    'profile.noLatePayments': 'Sin atrasos',
    'profile.accountActive': 'Cuenta activa desde hace {age}',
    'profile.accountAgeValue': '3 años y 2 meses',
    'profile.scoreTips': 'Consejos para tu Score',
    'profile.rec1': 'Mantén tus pagos al día',
    'profile.rec2': 'Evita utilizar más del 30% del límite',
    'profile.rec3': 'Diversifica tus fuentes de crédito',
    'profile.logout': 'Cerrar Sesión',
    'profile.backToDashboard': 'Volver al Panel',
  },
  en: {
    'profile.loading': 'Loading profile...',
    'profile.title': 'My Profile',
    'profile.subtitle': 'Manage your personal information and settings',
    'profile.defaultName': 'DogBank Customer',
    'profile.customerSince': 'Customer since 2023',
    'profile.premiumAccount': 'Premium Account',
    'profile.verified': 'Verified',
    'profile.personalInfo': 'Personal Information',
    'profile.fullName': 'Full Name',
    'profile.email': 'Email',
    'profile.phone': 'Phone',
    'profile.pixKey': 'PIX Key',
    'profile.address': 'Address',
    'profile.street': 'Street',
    'profile.complement': 'Complement',
    'profile.neighborhood': 'Neighborhood',
    'profile.cityState': 'City/State',
    'profile.zipCode': 'Postal Code',
    'profile.bankingData': 'Banking Details',
    'profile.bank': 'Bank',
    'profile.bankCode': 'Code: {code}',
    'profile.agency': 'Branch',
    'profile.account': 'Account',
    'profile.appearance': 'App Appearance',
    'profile.appearanceDesc': 'Choose the brand color used in this account.',
    'profile.appColorAria': 'App color',
    'profile.appearanceNote': 'The preference is saved only for this user and applied immediately.',
    'profile.creditAnalysis': 'Credit Analysis',
    'profile.scoreOf': 'of {max}',
    'profile.ratingExcellent': 'Excellent',
    'profile.totalLimit': 'Total Limit',
    'profile.usedLimit': 'Used Limit',
    'profile.availableLimit': 'Available Limit',
    'profile.utilized': '{pct}% used',
    'profile.noLatePayments': 'No late payments',
    'profile.accountActive': 'Account active for {age}',
    'profile.accountAgeValue': '3 years and 2 months',
    'profile.scoreTips': 'Tips for your Score',
    'profile.rec1': 'Keep your payments up to date',
    'profile.rec2': 'Avoid using more than 30% of your limit',
    'profile.rec3': 'Diversify your credit sources',
    'profile.logout': 'Sign Out',
    'profile.backToDashboard': 'Back to Dashboard',
  },
  it: {
    'profile.loading': 'Caricamento profilo...',
    'profile.title': 'Il Mio Profilo',
    'profile.subtitle': 'Gestisci le tue informazioni personali e le impostazioni',
    'profile.defaultName': 'Cliente DogBank',
    'profile.customerSince': 'Cliente dal 2023',
    'profile.premiumAccount': 'Conto Premium',
    'profile.verified': 'Verificato',
    'profile.personalInfo': 'Informazioni Personali',
    'profile.fullName': 'Nome Completo',
    'profile.email': 'Email',
    'profile.phone': 'Telefono',
    'profile.pixKey': 'Chiave PIX',
    'profile.address': 'Indirizzo',
    'profile.street': 'Via',
    'profile.complement': 'Interno',
    'profile.neighborhood': 'Quartiere',
    'profile.cityState': 'Città/Provincia',
    'profile.zipCode': 'CAP',
    'profile.bankingData': 'Dati Bancari',
    'profile.bank': 'Banca',
    'profile.bankCode': 'Codice: {code}',
    'profile.agency': 'Filiale',
    'profile.account': 'Conto',
    'profile.appearance': 'Aspetto dell\'applicazione',
    'profile.appearanceDesc': 'Scegli il colore del marchio usato in questo conto.',
    'profile.appColorAria': 'Colore dell\'applicazione',
    'profile.appearanceNote': 'La preferenza viene salvata solo per questo utente e applicata immediatamente.',
    'profile.creditAnalysis': 'Analisi del Credito',
    'profile.scoreOf': 'di {max}',
    'profile.ratingExcellent': 'Eccellente',
    'profile.totalLimit': 'Limite Totale',
    'profile.usedLimit': 'Limite Utilizzato',
    'profile.availableLimit': 'Limite Disponibile',
    'profile.utilized': '{pct}% utilizzato',
    'profile.noLatePayments': 'Nessun ritardo',
    'profile.accountActive': 'Conto attivo da {age}',
    'profile.accountAgeValue': '3 anni e 2 mesi',
    'profile.scoreTips': 'Consigli per il tuo Score',
    'profile.rec1': 'Mantieni i pagamenti aggiornati',
    'profile.rec2': 'Evita di utilizzare più del 30% del limite',
    'profile.rec3': 'Diversifica le tue fonti di credito',
    'profile.logout': 'Esci dall\'Account',
    'profile.backToDashboard': 'Torna alla Dashboard',
  },
};

export default profile;
